import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  schoolAdminDeleteAction,
  schoolAdminResetPassAction,
  schoolAdminSuspendAction,
  switchToAdminAction,
  teacheResetPassAction,
  teacherDeleteAction,
  teacherSuspendAction,
} from "../Redux/Action/teacherAction";
import {
  studentDeleteAction,
  studentResetPassAction,
  studentSuspendAction,
} from "../Redux/Action/studentAction";
import { schoolResetPassAction } from "../Redux/Action/schoolAction";
import {
  notificationDeleteAction,
  notificationListAction,
} from "../Redux/Action/notificationAction";
import {
  ConvertToTeacherAction,
  ManageAdminDeleteAction,
  SubAdminSuspendAction,
} from "../Redux/Action/manageAdminAction";
import { adminSubResetPasswordAction } from "../Redux/Action/authAction";
import { ManageContentDeleteAction } from "../Redux/Action/manageContentAction";
import {
  parentDeleteAction,
  parentResetPassAction,
  parentSuspendAction,
} from "../Redux/Action/parentAction";
import {
  workerDeleteAction,
  workerResetPassAction,
  workerSuspendAction,
  workerdetailsAction,
} from "../Redux/Action/workerAction";
import { deleteAction } from "../Redux/Action/categoryAction";
import {
  deletePackAction,
  getAllPacksAction,
} from "../Redux/Action/addOnPackAction";

const ConfirmModal = ({
  isModalOpen,
  handleConfirmClose,
  data,
  selectedType,
  extraFunction,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [canUpdateYearGroups, setCanUpdateYearGroups] = useState(true);
  const [canManageAdmins, setCanManageAdmins] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showForceDelete, setShowForceDelete] = useState(false);

  const handleModalClose = () => {
    setErrorMessage("");
    setShowForceDelete(false);
    handleConfirmClose();
  };
  const handleDeleteNotification = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(notificationDeleteAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate("/push-notifications");
        handleConfirmClose();
        const payload = {
          page: 0,
          limit: 20,
        };
        dispatch(notificationListAction(payload));
        toast.success("Notifications Deleted Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeletePack = async (forceDelete = false) => {
    try {
      const value = {
        id: data,
        check: forceDelete ? "Damn sure" : "Sure",
      };
      await dispatch(deletePackAction(value))
        .unwrap()
        .then((res) => {
          console.log("delete response", { res });
          if (res?.statusCode == 200) {
            navigate("/strategy-packs");
            handleConfirmClose();
            setErrorMessage("");
            setShowForceDelete(false);
            const payload = {
              page: 0,
              limit: 20,
            };
            dispatch(getAllPacksAction(payload));
            toast.success("Pack Deleted Successfully", {
              iconTheme: {
                primary: "#4318ff",
                secondary: "#FFFAEE",
              },
            });
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          if (error?.statusCode === 400) {
            setErrorMessage(error?.message);
            setShowForceDelete(true);
          } else {
            toast.error(error?.message || "An error occurred");
          }
        });
    } catch (error) {
      console.log("error", error);
      if (error?.statusCode === 400) {
        setErrorMessage(error?.message);
        setShowForceDelete(true);
      } else {
        toast.error(error?.message || "An error occurred");
      }
    }
  };

  const handleSubAdminDelete = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(ManageAdminDeleteAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate("/manage-admins");
        handleConfirmClose();

        toast.success("Notifications Deleted Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeleteContentVideo = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(ManageContentDeleteAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate("/manage-content");
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleteacherSuspend = async () => {
    try {
      const value = {
        id: data?._id,
      };
      const res = await dispatch(teacherSuspendAction(value));
      if (res?.payload?.statusCode == 200) {
        // navigate("/teachers");
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSchoolAdminSuspend = async (type) => {
    try {
      const value = {
        id: data?._id,
        isBlocked: type == "schoolAdminSuspend" ? true : false,
      };
      const res = await dispatch(schoolAdminSuspendAction(value));
      if (res?.payload?.statusCode == 200) {
        // navigate("/teachers");
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleStudentSuspend = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(studentSuspendAction(value));
      if (res?.payload?.statusCode == 200) {
        // navigate("/students");
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSubAdminSuspend = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(SubAdminSuspendAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate("/manage-admins");
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handlesubAdminResetPassword = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(adminSubResetPasswordAction(value));
      if (res?.payload?.statusCode == 200) {
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleteacherDelete = async () => {
    try {
      const value = {
        id: data?._id,
      };
      const res = await dispatch(teacherDeleteAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate(-1);
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleschoolAdminDelete = async () => {
    try {
      const value = {
        id: data?._id,
        isDeleted: true,
      };
      const res = await dispatch(schoolAdminDeleteAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate(-1);
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleStudentDelete = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(studentDeleteAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate(-1);
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleResetPassword = async (type) => {
    try {
      let payload;
      payload = {
        id: data,
      };
      let res;
      if (type === "studentResetPassword") {
        res = await dispatch(studentResetPassAction(payload));
      } else if (type === "teacherResetPassword") {
        res = await dispatch(teacheResetPassAction({ id: data?._id }));
      } else if (type === "schoolAdminResetPassword") {
        res = await dispatch(schoolAdminResetPassAction({ id: data?._id }));
      } else {
        res = await dispatch(schoolResetPassAction(payload));
      }
      if (res?.payload?.statusCode == 200) {
        if (type === "studentResetPassword") {
          handleConfirmClose();
        } else if (type === "teacherResetPassword") {
          // navigate("/teachers");
          handleConfirmClose();
        } else {
          handleConfirmClose();
        }
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleParentDeleteAction = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(parentDeleteAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate(-1);
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleConvertToTeacherAction = async () => {
    try {
      const value = {
        id: data?._id,
        schoolId: data?.schoolId?._id,
        switchedIntoTeacher: true,
      };
      const res = await dispatch(ConvertToTeacherAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate(-1);
        handleConfirmClose();
        extraFunction();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleParentresetPassAction = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(parentResetPassAction(value));
      if (res?.payload?.statusCode == 200) {
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSwitchToAdminAction = async () => {
    try {
      const value = {
        permissionToUpdateYearGroups: canUpdateYearGroups,
        permissionToManageAdmins: canManageAdmins,
        id: data?._id,
        schoolId: data?.schoolId?._id,
        switchedIntoSchoolAdmin: true,
      };
      const res = await dispatch(switchToAdminAction(value));
      if (res?.payload?.statusCode == 200) {
        handleConfirmClose();
        navigate(-1);
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleParentActivateAction = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(parentSuspendAction(value));
      if (res?.payload?.statusCode == 200) {
        // navigate("/parents");
        handleConfirmClose();
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleWorkerDeleteAction = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(workerDeleteAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate(-1);
        handleConfirmClose();
        toast.success(res?.payload?.message || "Worker deleted successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message || "Failed to delete worker");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleWorkerResetPassAction = async () => {
    try {
      const value = {
        id: data,
      };
      const res = await dispatch(workerResetPassAction(value));
      if (res?.payload?.statusCode == 200) {
        handleConfirmClose();
        toast.success(res?.payload?.message || "Password reset successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message || "Failed to reset password");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleWorkerActivateAction = async () => {
    try {
      const isSuspending = selectedType === "workerSuspend";
      const idVal = data?._id || data;
      const value = {
        id: idVal,
        status: isSuspending ? true : false,
      };
      const res = await dispatch(workerSuspendAction(value));
      if (res?.payload?.statusCode == 200) {
        handleConfirmClose();
        if (idVal) {
          dispatch(workerdetailsAction({ id: idVal }));
        }
        toast.success(res?.payload?.message || "Account status updated", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message || "Failed to update account status");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Modal
      show={isModalOpen}
      onHide={handleModalClose}
      className="comn-modal-set"
    >
      {selectedType === "studentResetPassword" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Reset Password
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Reset Password?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "convertToTeacher" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Change To Teacher
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              Are you sure you want to change this user’s role? For security
              reasons, this will prompt the user to reset their password before
              accessing the Teacher Portal.
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "schoolResetPassword" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Reset Password
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Reset Password?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "subAdminrestPassword" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Reset Password
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Reset Password?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "parentResetPassword" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Reset Password
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Reset Password?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "swichToAdmin" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Are you Sure ?
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              You want to change this user’s role? For security reasons, this
              will prompt the user to reset their password before accessing the
              Teacher Portal.
            </p>

            <div className="converting-sec">
              
              <Form.Group
                className="mb-3"
                controlId="permissionToUpdateYearGroups"
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                  }}
                >
                  <Form.Label style={{ marginBottom: 0, fontSize: "12px" }}>
                    Allow this Admin to change a Learner’s Year Group
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    id="permissions-switch1"
                    name="permissionToUpdateYearGroups"
                    className="mt-1"
                    checked={canUpdateYearGroups}
                    onChange={(e) => setCanUpdateYearGroups(e.target.checked)}
                    style={{
                      transform: "scale(1.5)",
                      transformOrigin: "right center",
                      marginLeft: "20px",
                    }}
                  />
                </div>
              </Form.Group>

              
              <Form.Group className="mb-3" controlId="permissionToManageAdmins">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <Form.Label style={{ marginBottom: 0, fontSize: "12px" }}>
                    Allow this Admin to create and manage Admins
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    id="permissions-switch2"
                    name="permissionToManageAdmins"
                    className="mt-1"
                    checked={canManageAdmins}
                    onChange={(e) => setCanManageAdmins(e.target.checked)}
                    style={{
                      transform: "scale(1.5)",
                      transformOrigin: "right center",
                      marginLeft: "20px",
                    }}
                  />
                </div>
              </Form.Group>
            </div>
          </Modal.Body>
        </>
      )}

      {selectedType === "teacherResetPassword" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Reset Password
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Reset Password?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "schoolAdminResetPassword" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Reset Password
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Reset Password?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "parentDelete" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Account Delete
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to delete?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "NotificationDelete" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Notification Delete
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to delete?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "PackDelete" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Pack Delete
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {errorMessage || "Are you sure you want to delete this Pack?"}
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "StudentDelete" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Student Delete
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to delete?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "deleteContentVideo" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Video Delete
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to delete?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "teacherDelete" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Delete Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to delete?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "schoolAdminDelete" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Delete Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to delete?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "subAdminDelete" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Delete Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to delete?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "teacherSuspend" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Suspend Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Suspend?
            </p>
          </Modal.Body>
        </>
      )}
      {selectedType === "schoolAdminSuspend" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Suspend Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Suspend?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "parentSuspend" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Suspend Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Suspend?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "parentActiveAccount" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Activate Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to activate this account?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "workerSuspend" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Suspend Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Suspend?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "workerActiveAccount" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Activate Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to activate this account?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "workerDelete" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Delete Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to delete this account?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "workerResetPassword" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Reset Password
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Reset Password?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "teacherActiveAccount" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Activate Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to activate this account?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "schoolAdminActiveAccount" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Activate Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to activate this account?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "StudentSuspend" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Suspend Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Suspend?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "studentActiveAccount" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Activate Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to activate this account?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "subAdminSuspend" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Suspend Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to Suspend?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "subAdminActiveAccount" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Activate Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              {" "}
              Are you sure you want to activate this account?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "RemoveSchool" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Remove School
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              Are you sure you want to remove this school from the pack?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "removeSchoolMember" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Remove from School
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              Are you sure you want to remove this student from the school?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "removeSchoolParent" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Remove from School
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              Are you sure you want to remove this parent from the school?
            </p>
          </Modal.Body>
        </>
      )}

      {selectedType === "removeSchoolWorker" && (
        <>
          <Modal.Header className="border-none" closeButton>
            <Modal.Title className="text-center modal-title ">
              Remove from School
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="text-center suspend-text">
              Are you sure you want to remove this worker from the school?
            </p>
          </Modal.Body>
        </>
      )}

      <Modal.Footer className="border-none justify-content-center modal-footer">
        {selectedType === "teacherResetPassword" && (
          <Button
            onClick={() => handleResetPassword("teacherResetPassword")}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "schoolAdminResetPassword" && (
          <Button
            onClick={() => handleResetPassword("schoolAdminResetPassword")}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "studentResetPassword" && (
          <Button
            onClick={() => handleResetPassword("studentResetPassword")}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "schoolResetPassword" && (
          <Button
            onClick={() => handleResetPassword("schoolResetPassword")}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "NotificationDelete" && (
          <Button
            onClick={() => handleDeleteNotification()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn"
          >
            Yes
          </Button>
        )}
        {selectedType === "PackDelete" && (
          <>
            {showForceDelete ? (
              <Button
                onClick={() => handleDeletePack(true)}
                variant="danger"
                className="modal-close-btn pop-cancel-btn"
              >
                Yes, Delete Anyway
              </Button>
            ) : (
              <Button
                onClick={() => handleDeletePack()}
                variant="secondary"
                className="modal-close-btn pop-cancel-btn"
              >
                Yes
              </Button>
            )}
          </>
        )}

        {selectedType === "teacherSuspend" && (
          <Button
            onClick={() => handleteacherSuspend()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "schoolAdminSuspend" && (
          <Button
            onClick={() => handleSchoolAdminSuspend("schoolAdminSuspend")}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "teacherActiveAccount" && (
          <Button
            onClick={() => handleteacherSuspend()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "schoolAdminActiveAccount" && (
          <Button
            onClick={() => handleSchoolAdminSuspend("schoolAdminActiveAccount")}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "teacherDelete" && (
          <Button
            onClick={() => handleteacherDelete()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "schoolAdminDelete" && (
          <Button
            onClick={() => handleschoolAdminDelete()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "studentActiveAccount" && (
          <Button
            onClick={() => handleStudentSuspend()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn"
          >
            Yes
          </Button>
        )}

        {selectedType === "StudentSuspend" && (
          <Button
            onClick={() => handleStudentSuspend()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "subAdminActiveAccount" && (
          <Button
            onClick={() => handleSubAdminSuspend()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "subAdminSuspend" && (
          <Button
            onClick={() => handleSubAdminSuspend()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn"
          >
            Yes
          </Button>
        )}

        {selectedType === "subAdminDelete" && (
          <Button
            onClick={() => handleSubAdminDelete()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "subAdminrestPassword" && (
          <Button
            onClick={() => handlesubAdminResetPassword()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "StudentDelete" && (
          <Button
            onClick={() => handleStudentDelete()}
            variant="secondary"
            className="modal-close-btn  pop-cancel-btn"
          >
            Yes
          </Button>
        )}

        {selectedType === "deleteContentVideo" && (
          <Button
            onClick={() => handleDeleteContentVideo()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "parentActiveAccount" && (
          <Button
            onClick={() => handleParentActivateAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "parentSuspend" && (
          <Button
            onClick={() => handleParentActivateAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "parentDelete" && (
          <Button
            onClick={() => handleParentDeleteAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "convertToTeacher" && (
          <Button
            onClick={() => handleConvertToTeacherAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "parentResetPassword" && (
          <Button
            onClick={() => handleParentresetPassAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "workerActiveAccount" && (
          <Button
            onClick={() => handleWorkerActivateAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "workerSuspend" && (
          <Button
            onClick={() => handleWorkerActivateAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "workerDelete" && (
          <Button
            onClick={() => handleWorkerDeleteAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "workerResetPassword" && (
          <Button
            onClick={() => handleWorkerResetPassAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "swichToAdmin" && (
          <Button
            onClick={() => handleSwitchToAdminAction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn "
          >
            Yes
          </Button>
        )}

        {selectedType === "RemoveSchool" && (
          <Button
            onClick={() => extraFunction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn"
          >
            Yes
          </Button>
        )}

        {(selectedType === "removeSchoolMember" ||
          selectedType === "removeSchoolParent" ||
          selectedType === "removeSchoolWorker") && (
          <Button
            onClick={() => extraFunction()}
            variant="secondary"
            className="modal-close-btn pop-cancel-btn"
          >
            Yes
          </Button>
        )}

        <Button
          variant="primary"
          onClick={handleModalClose}
          className="modal-f-btn pop-cancel-btn"
        >
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
